import React from "react";
import Axios from "axios";
import { Button, Modal, Space, Table, Tooltip, Typography } from "antd";
import { EditOutlined, PlusOutlined, DeleteOutlined, QuestionCircleOutlined, SyncOutlined } from "@ant-design/icons";

import AddEditECSFRolesModalForm from "./modals/AddEditECSFRolesModalForm";
import { Config } from "./config_section.js";

const { confirm } = Modal;
const { Title } = Typography;


const ECSFRoles = ({ refresh, showMessage, authData, usersData, dbECSFRoles }) => {
  const [editRecord, setEditRecord] = React.useState(null);

  function showConfirmAction(id, isArchived) {
    confirm({
      title: isArchived ? "Are you sure you want to restore this ECSF role?" : "Are you sure you want to archive this ECSF role?",

      content: (
        <div>
          <p>
            <b>Name:</b> {dbECSFRoles.find((obj) => obj.id === id).name}
          </p>
        </div>
      ),

      icon: <QuestionCircleOutlined style={{ color: "red" }} />,
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      async onOk() {
        try {
          return await new Promise((resolve, reject) => {
            Axios.post(Config.server.archiveECSFRole, { ...authData, id: id }, { headers: { "Content-Type": "application/json" } })
              .then((response) => {
                if (response && response.data.error === false) {
                  showMessage({ type: "success", content: `Record successfully ${isArchived ? "unarchived" : "archived"}.` });
                  refresh();
                  resolve();
                } else {
                  showMessage({ type: "error", content: "Something went wrong." });
                  reject();
                }
              })
              .catch((error) => {
                console.log(error);
                showMessage({ type: "error", content: "Something went wrong." });
                reject();
              });
          });
        } catch {
          showMessage({ type: "error", content: "Something went wrong." });
        }
      },
    });
  }


  const tableColumns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: "48px",
      sorter: (a, b) => a.id - b.id,
    },
    {
      title: "ECSF Role",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: "Updated [CET]",
      dataIndex: "updated",
      key: "updated",
      width: "160px",
      sorter: (a, b) => a.updated.localeCompare(b.updated),
    },
    {
      title: "Created [CET]",
      dataIndex: "created",
      key: "created",
      width: "160px",
      sorter: (a, b) => a.created.localeCompare(b.created),
    },
    {
      title: "Archived [CET]",
      dataIndex: "archived",
      key: "archived",
      width: "160px",
      sorter: (a, b) => a.archived.localeCompare(b.archived),
    },
    {
      title: "Action",
      key: "action",
      width: "60px",
      render: (record) => (
        <Space size="small">
          <Tooltip title="Edit row">
            <EditOutlined className="editIcon" onClick={() => setEditRecord(dbECSFRoles.find((obj) => obj.id === record.id))} />
          </Tooltip>
          <Tooltip title={record.archived ? "Restore row" : "Archive row"}>
            {record.archived ? (
              <SyncOutlined className="restoreIcon" onClick={() => showConfirmAction(record.id, true)} />
            ) : (
              <DeleteOutlined className="deleteIcon" onClick={() => showConfirmAction(record.id, false)} />
            )}
          </Tooltip>
        </Space>
      ),
    },
  ];

  return (
    <div id="ecsfroles">
      <Title className="pageTitle">ECSF Role</Title>

      <div className="dataHandleButtons">
        <Space>
          <Button onClick={() => setEditRecord("new")}>
            <PlusOutlined className="icon-position-fix" /> Add ECSF Role
          </Button>
        </Space>
      </div>
      <Table size="small" className="data-table" dataSource={dbECSFRoles} pagination={false} columns={tableColumns} rowClassName={(role) => (role.archived ? "archived-row" : "")}/>

      <AddEditECSFRolesModalForm
        editRecord={editRecord}
        refresh={refresh}
        onCancel={() => setEditRecord(null)}
        showMessage={showMessage}
        authData={authData}
        usersData={usersData}
        dbECSFRoles={dbECSFRoles}
      />
    </div>
  );
};

export default ECSFRoles;
